export { GetDictationResultByUserQuery } from './get-dictation-result-by-user';
export { GetDictationResultsCollectionByUserQuery } from './get-dictation-results-by-user';
export { GetDictationUsersCollectionQuery } from './get-dictation-users-collection';
export { GetUserQuery } from './get-user';
